import { render, staticRenderFns } from "./GestioneModelloDocumento.vue?vue&type=template&id=05ed19e4&"
import script from "./GestioneModelloDocumento.vue?vue&type=script&lang=js&"
export * from "./GestioneModelloDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports